import styled from 'styled-components';
import { Typography } from '../Typography';

export const Container = styled.label`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const StyledSpan = styled(Typography)`
  font-family: ${({ theme }) => theme.fonts.archivo};
  margin-left: 8px;
`;

export const CheckboxInput = styled.input`
  cursor: pointer;
  border: 2px solid ${({ theme }) => theme.colors.primary.main};
  border-radius: 2px;
  :focus {
    outline: none;
    box-shadow: none;
  }
`;
